import Select from "react-select";
import CustomButton from "../buttons/CustomButton";
import { reactSelectStyles } from "../../assets/js/react-select-styles";
import useGetAllTrips from "@hooks/trip/useGetAllTrips";
import DatePicker from "react-datepicker";
import useGetAllCustomers from "@hooks/customer/useGetAllCustomers";
import useGetAllPaymentTypes from "@hooks/common/useGetAllPaymentTypes";
import { useState } from "react";
import { formatFilterDate } from "@utils/general/format-filter-date";
import useGetAllWarehouses from "@hooks/warehouse-and-inventory/useGetAllWarehouses";

const AllocationAccountFilter = (props: {
  filterRef: React.MutableRefObject<{
    main_warehouse_id: undefined;
  }>;
  refetch: () => void;
}) => {
  const { filterRef, refetch } = props;

  const { customerData } = useGetAllCustomers({ limit: 1000 });
  const { warehouseData } = useGetAllWarehouses({
    limit: 1000,
    warehouse_type: 1,
  });
  const { paymentTypeData } = useGetAllPaymentTypes();
  const [curFromDate, setCurFromDate] = useState<Date | null>(null);
  const [curToDate, setCurToDate] = useState<Date | null>(null);

  const formattedCustomerData = customerData?.map((c) => ({
    label: c.customer_first_name + " " + (c.customer_last_name || "..."),
    value: c.customer_id,
  }));

  const formattedWarehouseData = warehouseData?.map((c) => ({
    label: c.warehouse_name,
    value: c.warehouse_id,
  }));

  const onChangeHandler = (val: any, key: string) => {
    const { value } = val;

    if (key === "from_date" || key === "to_date") {
      filterRef.current = {
        ...filterRef.current,
        [key]: formatFilterDate(val),
      };

      return;
    }

    filterRef.current = {
      ...filterRef.current,
      [key]: value,
    };
  };

  return (
    <div className="flex items-end mb-5">
      <div className="mr-6 basis-[20%]">
        <label className="mb-2 text-gray-700" htmlFor="name">
          Main Warehouse
        </label>
        <Select
          styles={reactSelectStyles}
          placeholder="All"
          options={formattedWarehouseData}
          //@ts-ignore
          onChange={(val) => onChangeHandler(val, "main_warehouse_id")}
        />
      </div>

      <div className="basis-1/6">
        <CustomButton
          handleClick={() => {
            refetch();
          }}
          className="w-24 h-[2.4rem]"
          title="Filter"
        />
      </div>
    </div>
  );
};

export default AllocationAccountFilter;
